<mat-toolbar color="accent">Select a plan</mat-toolbar>
<mat-dialog-content>
  <pr-treatment-plan-list
    [treatmentPlans]="data.planPairs"
    [todaysPlan]="data.todaysPlan"
    [selectedPlan]="data.selectedPlan"
    (selectPlan)="selectPlan($event)"
    (createPlan)="createPlan()"
   />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
